import { apis } from 'utils/lib/apis';
import { captureException } from "@sentry/react";

export const handleListClassesByTeacher = (teacherId) => async (dispatch) => {
    if (!teacherId) return [];
    
    try {
        const classes = await apis.get('customAssignments', `/listClassesByTeacher/${teacherId}`);
        return Array.isArray(classes) ? classes : [];
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`Error in handleListClassesByTeacher: ${error}`);
        }
        return [];
    }
};

export const handleBringDataFromSection = (data) => async (dispatch) => {
    try {
        const result = await apis.post('customAssignments', `/bringDataFromSection`, {
            body: data
        });
        return result;
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`Error in handleBringDataFromSection: ${error}`);
        }
        throw error;
    }
};

export const handleListLastSemActiveClass = (classId) => async (dispatch) => {
    try {
        const result = await apis.get('customAssignments', `/listLastSemActiveClass/${classId}`);
        return Array.isArray(result) ? result : [];
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`Error in handleListLastSemActiveClass: ${error}`);
        }
        return [];
    }
};

export const handleCheckClassSyncStatus = (classId) => async (dispatch) => {
    try {
        const result = await apis.get('customAssignments', `/checkClassSyncStatus/${classId}`);
        return result;
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`Error in handleCheckClassSyncStatus: ${error}`);
        }
        return { isSynced: false, syncedClasses: [] };
    }
};

export const handleUndoBringDataFromSection = (data) => async (dispatch) => {
    try {
        const result = await apis.post('customAssignments', `/undoBringDataFromSection`, {
            body: data
        });
        return result;
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`Error in handleUndoBringDataFromSection: ${error}`);
        }
        throw error;
    }
};
